import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import * as utils from '@utils'
import { Spin, Icon } from 'antd';

class MsgDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'MsgDialog')
        }
    }

    state = {
        dialogOpen: false,
    }

    componentDidMount() {
        this.props.onRef(this.dialog)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    dialog = {
        OpenDialog: () => {
            this.setState({ dialogOpen: true })
        },
        closeDialog: () => {
            this.setState({ dialogOpen: false })
        },
    }

    antIcon() {
        return <Icon type="loading" style={{ fontSize: 18 }} spin />
    }

    render() {
        const Buttons = () => {
            const items = []
            for (const idx in this.props.buttons) {
                const action = this.props.buttons[idx].action
                items.push(
                    <Button
                        variant="contained"
                        onClick={() => {
                            action()
                        }}
                        color="primary"
                        key={idx}
                        disabled={this.props.buttons[idx].disabled || (this.props.buttons[idx]?.useLoading && this.props?.loading)}
                        {...this.props.buttons[idx].options}>
                        {this.props.buttons[idx]?.useLoading && this.props?.loading && <Spin indicator={this.antIcon()} className={this.props.classes.loadingIcon} />}
                        {this.props.buttons[idx].text}
                    </Button>
                )
            }

            return items
        }

        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })} maxWidth={'xs'} fullWidth>
                <DialogTitle>{this.props.type ? this.t(this.props.type) : ''}</DialogTitle>
                <DialogContent>
                    <Typography style={{ whiteSpace: 'pre-line' }}>{this.props.msg}</Typography>
                </DialogContent>
                <Divider />
                <DialogActions>{Buttons()}</DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        loadingIcon: {
            marginRight: _theme.spacing(1),
            color: '#fff',
            lineHeight: 1
        },
    }
}

MsgDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    type: PropTypes.string.isRequired,
    msg: PropTypes.string.isRequired,
    buttons: PropTypes.array.isRequired,
    loading: PropTypes.bool
}

export default hoc(styles)(MsgDialog)
